// extracted by mini-css-extract-plugin
export default {"form":"styles_form__LVHzG","container":"styles_container__Wn3uM","input":"styles_input__eM3AN","image":"styles_image__m7e4P","headerContainer":"styles_headerContainer__PDwyL"};